export { IAlleleEplet } from './allele-eplet';
export { IAlleleOverride } from './allele-override';
export { IHlaAllele } from './hla-allele';
export { IHlaEplet } from './hla-eplet';
export { HlaLocusGroup } from './hla-locus-group';
export { IMedicalRecordAllele } from './hla-medical-record-allele';
